import React from "react";
import { useLocation } from "react-router-dom";
import { useLocalizedNavigate } from "@/hooks/useLocalizedNavigate";
import { handleFooterNavClick } from "./navLinkHandler";
import { FooterBrand, FooterContact, FooterCopyright } from "./FooterShared";
import "./footerZh.less";

const FOOTER_COPY = {
  qr1: "信维智算公众号",
  qr2: "维云云设备公众号",
  contactTitle: "联系我们",
  mainLine: "总机号码",
  afterSales: "售后部门",
  fax: "传真号码",
  copyright: "版权所有 广州信维电子科技股份有限公司 |",
  icp: "粤ICP备10023868号 |",
  psb: "粤公网安备44011602000125号",
};

const FooterZh = ({ navList, contactInfo, homePath }) => {
  const navigate = useLocalizedNavigate();
  const location = useLocation();

  return (
    <footer className="global-footer global-footer--zh light-theme">
      <div className="footer-zh themesCube middle">
        <div className="footer-zh__top flex">
          <FooterBrand
            homePath={homePath}
            qr1={FOOTER_COPY.qr1}
            qr2={FOOTER_COPY.qr2}
          />
          <div className="footer-zh__nav">
            {navList.map((val, index) => (
              <dl key={val.key} className="footer-zh__nav-group">
                <dt>{val.category}</dt>
                {(val.children ?? []).map((v, childIndex) => (
                  <dd key={`${index}-${childIndex}`}>
                    <a
                      href={v.path}
                      style={{ cursor: "pointer" }}
                      onClick={(e) =>
                        handleFooterNavClick(e, v, {
                          navigate,
                          location,
                          isAIServerChild: val.key === "ai-server",
                        })
                      }
                    >
                      {v.name}
                    </a>
                  </dd>
                ))}
              </dl>
            ))}
          </div>
          <FooterContact copy={FOOTER_COPY} contactInfo={contactInfo} />
        </div>
        <FooterCopyright copy={FOOTER_COPY} />
      </div>
    </footer>
  );
};

export default FooterZh;
